<template>
  <div class="middle">
    <!-- <div>
      <span>公司总发电量</span>
    </div>
    <div>
      <span>公司总供电量</span>
    </div> -->
    <div class="map" ref="map" :style="{width: '700px', height: '800px'}"></div>
  </div>
</template>

<script>
import echarts from 'echarts';
import addressJson from '@/assets/guizhou.json';
import axios from 'axios';
export default {
  name: 'echart-map',
  data() {
    return {
      id: 'echarts_' + new Date().getTime() + Math.floor(Math.random() * 1000),
      echartObj: null,
      radioList: {
      },
    }
  },
  props: ['powerStationList'],
  watch: {
    powerStationList: function (newVal, oldVal) {
      console.log("powerStationList")
      this.ecMapServicer()
    }
  },
  mounted() {
    this.ecMapServicer()
  },
  methods: {
    ecMapServicer() {
      let data_type_1 = []
      let data_type_2 = []
      let data_type_3 = []
      axios.get('/api/powermis/bigScreen/getPowerStation').then(response => {
        for (var i = 0; i < response.data.data.busPowerStationList.length; i++) {
          let securityStatus = response.data.data.busPowerStationList[i].securityStatus;
          let name = response.data.data.busPowerStationList[i].name;
          let coordinate = response.data.data.busPowerStationList[i].coordinate;
          if (coordinate) {
            coordinate = "[" + coordinate + "]";
            coordinate = JSON.parse(coordinate);
          }
          if (securityStatus == 1) {
            data_type_1.push({
              name: name,
              type: '安全',
              value: coordinate
            })
          } else if (securityStatus == 2) {
            data_type_2.push({
              name: name,
              type: '临界',
              value: coordinate
            })
          } else if (securityStatus == 3) {
            data_type_3.push({
              name: name,
              type: '危险',
              value: coordinate
            })
          }
        }
        var uploadedDataURL = addressJson;
        // 基于准备好的dom，初始化echarts实例
        var myChart = echarts.init(this.$refs.map);

        /*  {name:'武汉', geoCoord:[114.31, 30.52]}, x-y坐标轴起点[113.45, 29.95] */
        var markPointData = [
          {
            name: '贵阳',
            value: [106.713478, 26.578343],
            type: '地区'
          },
          {
            name: "六盘水",
            value: [104.846743, 26.584643],
            type: '地区'
          },
          {
            name: '遵义',
            value: [106.937265, 27.706626],
            type: '地区'
          },
          {
            name: '安顺',
            value: [105.932188, 26.245544],
            type: '地区'
          },
          {
            name: '毕节',
            value: [105.28501, 27.301693],
            type: '地区'
          },
          {
            name: '铜仁',
            value: [109.191555, 27.718346],
            type: '地区'
          },
          {
            name: '黔西南',
            value: [104.897971, 25.08812],
            type: '地区'
          },
          {
            name: '黔东南',
            value: [107.977488, 26.583352],
            type: '地区'
          },
          {
            name: '黔南',
            value: [107.517156, 26.258219],
            type: '地区'
          }
        ];
        // 显示加载动画
        var option = {}
        echarts.registerMap('mapData', addressJson);
        option = {
          color: ["#91c7ae", "#749f83", "#ca8622"], //颜色组
          tooltip: {
            trigger: "item",
            show: true,
            padding: 0,
            backgroundColor: "#ffffff33",
            formatter: function (params) {
              var str = `
            <div class="agency_information">
            <div class="agency_title">
              ${params.name}
              <label>（${params.data.type}）</label>
            </div>
          </div>
            `;
              return str;
            }
          },
          grid: {
            top: 200
          },
          legend: {
            orient: "vertical",
            icon: "pain",
            right: '10%',
            bottom: '10%',
            itemWidth: 20,
            itemHeight: 14,
            align: "left",
            textStyle: {
              color: "#fff",
              fontSize: 12
            },
            data: ["安全", "临界", "危险"]
          },
          xAxis: {
            show: false
          },
          yAxis: {
            show: false
          },
          geo: {
            show: true,
            map: "mapData",
            label: {
              normal: {
                show: false
              },
              emphasis: {
                show: false
              }
            },
            zoom: 1.8,
            roam: true,
            itemStyle: {
              areaColor: "#1A2B75",
              borderColor: "#3fdaff",
              borderWidth: 1
            },
            emphasis: {
              itemStyle: {
                areaColor: "#2B91B7"
              }
            }
          },
          series: [
            {
              name: 'credit_pm2.5',
              type: 'scatter',
              coordinateSystem: 'geo',
              data: markPointData,
              symbolSize: 5,
              label: {
                normal: {
                  formatter: '{b}',
                  position: 'right',
                  show: true
                },
                emphasis: {
                  show: true
                }
              },
              itemStyle: {
                normal: {
                  color: '#fff'
                }
              },
            },
            {
              name: '定位点',
              type: 'effectScatter', // 散点图
              coordinateSystem: 'geo', // 使用地理坐标系
              hoverAnimation: 'false',
              legendHoverLink: 'false',
              rippleEffect: {
                period: 4,
                brushType: 'stroke',
                scale: 3
              },
              data: data_type_1
            },
            {
              name: '定位点',
              type: 'effectScatter', // 散点图
              coordinateSystem: 'geo', // 使用地理坐标系
              hoverAnimation: 'false',
              legendHoverLink: 'false',
              rippleEffect: {
                period: 4,
                brushType: 'stroke',
                scale: 3
              },
              data: data_type_2
            },
            {
              name: '定位点',
              type: 'effectScatter', // 散点图
              coordinateSystem: 'geo', // 使用地理坐标系
              hoverAnimation: 'false',
              legendHoverLink: 'false',
              rippleEffect: {
                period: 4,
                brushType: 'stroke',
                scale: 3
              },
              data: data_type_3
            },
            // 一类
            {
              name: '安全',
              type: 'scatter',
              coordinateSystem: 'geo',
              symbol: 'pin',
              symbolSize: 40,
              label: {
                normal: {
                  show: false,
                  textStyle: {
                    color: '#fff',
                    fontSize: 9,
                  }
                }
              },
              itemStyle: {
                normal: {
                  color: "#00A0E9", //控制图例和地图标记点的颜色
                  borderWidth: 2
                }
              },
              data: data_type_1
            },
            // 二类
            {
              name: '临界',
              type: 'scatter',
              coordinateSystem: 'geo',
              symbol: 'pin',
              symbolSize: 40,
              label: {
                normal: {
                  show: false,
                  textStyle: {
                    color: '#fff',
                    fontSize: 9,
                  }
                }
              },
              itemStyle: {
                normal: {
                  color: "#11D53F", //控制图例和地图标记点的颜色
                  borderWidth: 2
                }
              },
              data: data_type_2
            },
            // 三类
            {
              name: "危险",
              type: "scatter",
              coordinateSystem: "geo",
              //symbol: "../../src/assets/redBi.png",
              //symbolSize: [14, 16],
              symbol: 'pin',
              symbolSize: 40,
              //label: {
              //  normal: {
              //    show: false,
              //    backgroundColor: "#2B91B7",
              //    position: "right",
              //    color: "#ffffff",
              //    fontSize: "14",
              //    padding: 20
              //  },
              //  emphasis: {
              //    show: false
              //  }
              //},
              label: {
                normal: {
                  show: false,
                  textStyle: {
                    color: '#fff',
                    fontSize: 9,
                  }
                }
              },
              itemStyle: {
                normal: {
                  color: "#ff0004",
                  borderWidth: 2
                }
              },
              data: data_type_3
            }
          ]
        };
        myChart.setOption(option);
      })
    }
  }
}
</script>

<style scope>
.agency_information {
  width: 250px;
  padding: 5px 0;
  background: transparent;
  border-radius: 5px;
}
.agency_title {
  min-width: 150px;
  height: auto;
  font-size: 14px;
  color: #ffffff;
  font-weight: normal;
  text-align: center;
}
.agency_type {
  color: #fe0101;
}
.agency_info_row {
  box-sizing: border-box;
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  height: auto;
  padding-left: 10px;
  background: #ffffff33;
  margin-bottom: 4px;
  font-size: 12px;
  color: #ffffff;
  font-weight: normal;
}
.agency_info_row > label:first-child {
  width: 60px;
  height: auto;
  margin-right: 20px;
  text-align: left;
}
.o-echarts {
  min-width: 30px;
  min-height: 30px;
  width: 100%;
  height: 100%;
}
.middle {
  display: flex;
  margin-left: 1.75%;
  justify-content: center;
  width: 20.52%;
}
.middle div:nth-child(1) {
  flex: 1;
}
.middle div span:nth-child(1) {
  background-image: -webkit-linear-gradient(top, #e8ffff, #6fdfe9);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 1.1vw;
  font-family: Hiragino Sans GB;
  font-weight: 900;
  color: rgba(255, 255, 255, 1);
}
.middle div span:nth-child(2) {
  background-image: -webkit-linear-gradient(top, #e8ffff, #7bd7ea);
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
  font-size: 1.1vw;
  /* margin-top: 23%; */
  font-family: Hiragino Sans GB;
  font-weight: 900;
  color: rgba(255, 255, 255, 1);
}
</style>



// WEBPACK FOOTER //
// src/components/middle.vue